import { BaseMapper, clampPercentage } from '@ps/utils';
import { SurveyQuota } from '@ps/survey-utils';

import { QuotaCriterionDto, QuotaDto } from '../dtos/quota.dto';

export class QuotaMapper extends BaseMapper<QuotaDto, SurveyQuota> {
  public fromDto(dto: QuotaDto): SurveyQuota {
    return {
      id: dto.buyer_quota_id,
      psQuotaId: dto.ps_quota_id,
      label: this._label(dto),
      groupKey: dto.group_key,
      locked: dto.locked,
      fielded: dto.achieved,
      goal: dto.current_target,
      currentlyOpen: dto.currently_open,
      maximum: dto.maximum,
      allocationPercentage: clampPercentage(dto.percentage),
      hasInField: !!dto.in_field?.total_complete,
      isUnknown: false,
      suppliers: (dto.suppliers ?? []).map((supplier) => ({
        currentTarget: supplier.current_target,
        completeNeeded: supplier.complete_needed,
      })),
    };
  }

  private _label(dto: QuotaDto): string {
    if (dto.quota_title) {
      return dto.quota_title;
    }
    const parts = dto.criteria
      .flatMap((criterion) => this._criterionLabels(criterion))
      .filter((part) => part.length > 0);
    return parts.length > 0 ? parts.join(', ') : dto.group_key;
  }

  /**
   * A criterion is labelled by its named conditions (e.g. "Male") or, for
   * range-based qualifications like Age, by its ranges (e.g. "18 - 24").
   */
  private _criterionLabels(criterion: QuotaCriterionDto): string[] {
    const conditions = (criterion.condition_names ?? []).filter(
      (name) => name.length > 0,
    );
    if (conditions.length > 0) {
      return conditions;
    }
    return (criterion.range_sets ?? [])
      .filter((range) => range.from != null && range.to != null)
      .map((range) => `${range.from} - ${range.to}`);
  }
}
